<template>
	<div class="h-100">
		<template v-if="gridView">
			<div class="cards-container-shimmer">
				<div class="h-90 asset-card" v-for="i in 20" :key="i">
					<div class="d-flex gap-2">
  <div style="padding-right: 0px;">
    <b-skeleton-img
      no-aspect
      height="57px"
      width="90px"
      border-radius="10px"
    ></b-skeleton-img>
  </div>

  <div
    class="mt-1 w-100"
    :class="{
      'ml-3': $route.name === 'coursecreation',
      'ml-2': $route.name !== 'assetbank' && $route.name !== 'coursecreation'
    }"
  >
    <b-skeleton class="w-80"></b-skeleton>
    <b-skeleton class="w-50 mt-2"></b-skeleton>
  </div>
</div>

				</div>
			</div>
		</template>
		<template v-else>
			<div class="h-100 ab-lv pb-0 mt-2">
				<b-table-simple class="ab-lv-bodytable overflow-auto" responsive>
					<b-tbody>
						<b-tr class="ab-lv-bodycards mt-2" v-for="i in 8" :key="i">
							<b-th style="width: 8%">
								<b-skeleton></b-skeleton>
							</b-th>
							<b-th style="width: 15%"></b-th>
							<b-th style="width: 5%">
								<b-skeleton></b-skeleton>
							</b-th>

							<b-th style="width: 5%">
								<b-skeleton></b-skeleton>
							</b-th>

							<b-th style="width: 5%">
								<b-skeleton></b-skeleton>
							</b-th>
							<b-th style="width: 15%"></b-th>
							<b-th style="width: 5%">
								<b-skeleton></b-skeleton>
							</b-th>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "SkeletonPage",
	props: {
		gridView: Boolean,
		shimmerType: String,
	},
};
</script>
<style scoped>
.b-skeleton-img {
	border-radius: 4px;
}
.asset-card {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	height: 67px;
	padding: 5px;
}
.cards-container-shimmer {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-gap: 12px 15px; /* 5px 45px */
	overflow: auto;
	padding: 10px 30px;
	align-content: baseline;
}
.ab-lv .ab-lv-header {
	height: 45px;
	background: #e9f0f5;
	border-radius: var(--size-5);
	font-family: "Lato", sans-serif;
	font-weight: var(--weight-600);
	font-size: var(--size-14);
	color: #20639b;
	white-space: nowrap;
}
.ab-lv-bodytable table {
	border-collapse: separate;
	border-spacing: var(--size-5) var(--size-10);
}
</style>
